// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-14pIo";
var _3 = "segmentInfo-3SD62";
var _4 = "segmentInfo__cityName-d1a8G";
var _5 = "aircraftInfoAndAmenities-1jqCK";
var _6 = "amenities-3fm3H";
var _7 = "company-2h1lY";
var _8 = "company__logo-3XzmN";
var _9 = "aircraftInfo-13lsR";
var _a = "company__name-2YeG4";
var _b = "segmentInfo__date-t9Svr";
var _c = "segmentInfo__airportIATA-3bRTF";
var _d = "flightNumber-r8hLW";
var _e = "routeArrow-2MoKU";
var _f = "stopsInfo-3KOzl";
var _10 = "route-32jzM";
var _11 = "timeInRoute-3epl2";
var _12 = "circle-3SGUy";
export { _1 as "__esModule", _2 as "root", _3 as "segmentInfo", _4 as "segmentInfo__cityName", _5 as "aircraftInfoAndAmenities", _6 as "amenities", _7 as "company", _8 as "company__logo", _9 as "aircraftInfo", _a as "company__name", _b as "segmentInfo__date", _c as "segmentInfo__airportIATA", _d as "flightNumber", _e as "routeArrow", _f as "stopsInfo", _10 as "route", _11 as "timeInRoute", _12 as "circle" }
export default { "__esModule": _1, "root": _2, "segmentInfo": _3, "segmentInfo__cityName": _4, "aircraftInfoAndAmenities": _5, "amenities": _6, "company": _7, "company__logo": _8, "aircraftInfo": _9, "company__name": _a, "segmentInfo__date": _b, "segmentInfo__airportIATA": _c, "flightNumber": _d, "routeArrow": _e, "stopsInfo": _f, "route": _10, "timeInRoute": _11, "circle": _12 }
